import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { CommonModule } from '@angular/common';
import { FormsModule as WorkappFormsModule } from './forms.module';
import { FormBuilderComponent } from './builder/form-builder.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-forms-test',
  standalone: true,
  imports: [CommonModule, WorkappFormsModule, FormBuilderComponent],
  templateUrl: './forms-test.component.html',
  styleUrls: ['./forms-test.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class FormsTestComponent implements OnInit {
  currentTab: 'list' | 'builder' = 'list';
  organizationId = '';
  editingTemplateId?: string;
  refreshListTrigger = 0;
  showBuilder = true;

  constructor(private router: Router) { }

  ngOnInit(): void {
    this.organizationId = SessionHelper.getChoosenOrg() || '';
    console.log('Forms test component loaded with org:', this.organizationId);
  }

  setTab(tab: 'list' | 'builder'): void {
    this.currentTab = tab;
  }

  onEditForm(templateId: string): void {
    console.log('Editing template (empty means new):', templateId);
    this.showBuilder = false;
    this.editingTemplateId = templateId ? templateId : undefined;
    this.currentTab = 'builder';
    setTimeout(() => {
      this.showBuilder = true;
    });
  }

  onFormSaved(): void {
    console.log('Form saved, refreshing list');
    this.refreshListTrigger++;
  }

  onFormPublished(): void {
    console.log('Form published, returning to list');
    this.refreshListTrigger++;
    this.currentTab = 'list';
  }

  goBack(): void {
    this.router.navigate(['/orgaccount']);
  }
}
